import MemberBenefitInfoContent from './MemberBenefitInfoContent';

export default MemberBenefitInfoContent;
